/* MACP: "In den Warenkorb" direkt auf Produktkarten (Startseite) */
(function(){
  var EN=(document.documentElement.lang||'').toLowerCase().indexOf('en')===0;
  function bubble(count){
    var icon=document.querySelector('cart-icon');
    if(icon&&typeof icon.renderCartBubble==='function'){icon.renderCartBubble(count);}
  }
  document.addEventListener('click',function(e){
    if(e.target.closest('.mc-atc')){e.stopPropagation();}
  },true);
  document.addEventListener('submit',function(e){
    var form=e.target.closest('form.mc-atc');
    if(!form||!window.fetch)return;
    e.preventDefault();
    var btn=form.querySelector('.mc-atc__btn');
    if(btn.disabled)return;
    var label=btn.textContent;
    btn.disabled=true;btn.textContent=EN?'Adding …':'Wird hinzugefügt …';
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    fetch(root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
      .then(function(r){if(!r.ok)throw r;return fetch(root+'cart.js',{headers:{'Accept':'application/json'}});})
      .then(function(r){return r.json();})
      .then(function(cart){
        bubble(cart.item_count);
        btn.textContent=EN?'✓ In cart':'✓ Im Warenkorb';btn.classList.add('is-added');
        setTimeout(function(){btn.textContent=label;btn.classList.remove('is-added');btn.disabled=false;},2500);
      })
      .catch(function(){btn.disabled=false;btn.textContent=label;form.submit();});
  });
})();
